import axiosClient from "@/libs/axiosClient";

export const getGroupAsset = ({ category, groupNames }) => {
    let params = { category };
    if (groupNames == "all") {
        params.groupNames = "";
    } else {
        params.groupNames = groupNames;
    }
    // if (groupNames !== undefined && groupNames.length > 0 && !groupNames.some(e => e == "*" || e == "all"))

    let queryString = new URLSearchParams(params).toString();

    return axiosClient.get(`/monitor/groupasset?${queryString}`);
};

export const getGroupPattern = ({ groupName }) => {
    let params = { groupName };

    let queryString = new URLSearchParams(params).toString();

    return axiosClient.get(`/group/rcm-edgegroup-pattern?${queryString}`);
};

export const updateGroupPattern = ({ groupName, data }) => {
    let params = { groupName };
    let queryString = new URLSearchParams(params).toString();

    return axiosClient.post(`/group/rcm-edgegroup-pattern?${queryString}`, data);
};

export const getGroupApiKeys = ({ groupName }) => {
    let params = { groupName };
    let queryString = new URLSearchParams(params).toString();

    return axiosClient.get(`/group/apikeys?${queryString}`);
};

export const updateGroupApiKeys = ({ groupName, data }) => {
    let params = { groupName };
    let queryString = new URLSearchParams(params).toString();

    return axiosClient.post(`/group/apikeys?${queryString}`, data);
};

export const updateSubscription = ({ category, groupNames, subscription }) => {
    var updateDataKey = category + "Subscription";
    var updateData = {};
    updateData[updateDataKey] = subscription;

    return axiosClient.post(`/table/rcm-edgegroup/update/partialUpdate`, {
        docId: groupNames,
        groupName: groupNames,
        updateData: updateData,
        esIndex: "rcm-edgegroups"
    });
};



// WEBPACK FOOTER //
// ./src/api/groupasset.js